import { useQuery } from '@tanstack/react-query'
import {
  type PlaceNode,
  PlaceNodeTypeEnum,
  PlacesApi,
} from '@ulysses-inc/harami_api_client'
import { getUniqueFlattenNodes } from 'src/exShared/util/place/getUniqueFlattenNodes'
import { flattenNodes } from 'src/exShared/util/place/placeNode'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

export type DevicePlaceNodes = {
  /** 現場グループの展開に使う、重複排除済みの全ノード (ネスト構造 .nodes を保持) */
  allNodes: PlaceNode[]
  /** 現場 (Place) のみ。現場名フィルタの選択肢 */
  places: PlaceNode[]
  /** 現場グループ (PlaceGroup) のみ。現場グループフィルタの選択肢 */
  placeGroups: PlaceNode[]
}

/**
 * 絞り込み・編集で使う現場ノードを取得する。
 * 現場グループを子現場に展開する必要があるため、簡略化せずツリー構造のまま flatten して保持する。
 *
 * 共通の useQueryPlaceNodes とは select 後の形 (allNodes/places/placeGroups) が異なるため、
 * queryKey を共有せずキオスク端末画面専用キーで管理する (キャッシュの相互 evict を避ける)。
 */
export const useQueryDevicePlaceNodes = () =>
  useQuery({
    queryKey: queryKeys.placeNodes,
    queryFn: () => baseClient.getApi(PlacesApi).getPlaceNodes(),
    select: (data): DevicePlaceNodes => {
      const allNodes = getUniqueFlattenNodes(flattenNodes(data))
      return {
        allNodes,
        places: allNodes.filter(node => node.type === PlaceNodeTypeEnum.Place),
        placeGroups: allNodes.filter(
          node => node.type === PlaceNodeTypeEnum.PlaceGroup,
        ),
      }
    },
    // 画面を二回目以降に開く際に、時間差でデータが更新されることによる事故を防ぐため
    gcTime: 0,
  })
